module.exports = marked;


//////////////////
// WEBPACK FOOTER
// external "marked"
// module id = 88
// module chunks = 0